import { Component } from '@angular/core';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-under-construction',
  standalone: true,
  imports: [MessageModule],
  template: `
    <div class="flex justify-content-center p-4">
      <p-message severity="warn" icon="pi pi-hammer" class="w-full max-w-30rem">
        <ng-template pTemplate="content">
          <div class="flex align-items-center gap-3 ml-2">
            <!-- Large Icon for visual emphasis -->
            <i class="pi pi-cog pi-spin text-2xl"></i>
            <div>
              <div class="font-bold text-lg">Page Under Construction</div>
              <div class="text-sm">
                We are working hard to bring you this feature. Please check back soon!
              </div>
            </div>
          </div>
        </ng-template>
      </p-message>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
      /* Simple spinning animation for the gear icon */
      .pi-spin {
        animation: fa-spin 2s infinite linear;
      }
      @keyframes fa-spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(359deg);
        }
      }

      /* Dark mode styling */
      :host-context(.axa-dark-mode) {
        ::ng-deep .p-message {
          background: #2a2d47 !important;
          border-color: rgba(251, 191, 36, 0.3) !important;
          color: #f7f8fc !important;

          .p-message-icon {
            color: #fbbf24 !important;
          }

          .p-message-text {
            color: #f7f8fc !important;
          }

          .font-bold {
            color: #ffffff !important;
          }

          .text-sm {
            color: #e5e7eb !important;
          }

          .pi-cog {
            color: #fbbf24 !important;
          }
        }
      }
    `,
  ],
})
export class UnderConstructionComponent {}
